import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { login, logout, getInfo, phoneLogin } from '@/api/user'
import { getToken, setToken, removeToken, setUserName, getUserName, removeUserName, setBbsToken } from '@/utils/auth'
import storage from '@/utils/storage'
import router from '@/router'
import Custom from './modules/custom.js'
Vue.use(Vuex)
const store = new Vuex.Store({
  namespaced:true,
  modules: {
    custom: Custom
  },
  state: {
    /* User */
    token: getToken(),
    curUserName: getUserName(),
    numbUserName: null,
    // username: null,
    username: localStorage.getItem('username') || null,
    userEmail: null,
    name: null,
    userAvatar: null,
    roles: [],
    /* NavBar */
    isNavBarVisible: true,

    /* FooterBar */
    isFooterBarVisible: true,

    /* Aside */
    isAsideVisible: false,
    isAsideMobileExpanded: false,

    /* Sample data (commonly used) */
    clients: []
  },
  mutations: {
    /* A fit-them-all commit */
    SET_USER_NAME (state, username) {
      if (username) {
        state.username = username
        localStorage.setItem('username', username) // 存储到 LocalStorage
      } else {
        state.username = null
        localStorage.removeItem("username")
      }
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.numbUserName = name
    },
    basic (state, payload) {
      state[payload.key] = payload.value
    },
    updateUsername ({ commit }, username) {
      commit('SET_USERNAME', username)
    },
    /* User */
    // user (state, payload) {
    //   if (payload.name) {
    //     state.userName = payload.name
    //   }
    //   if (payload.email) {
    //     state.userEmail = payload.email
    //   }
    //   if (payload.avatar) {
    //     state.userAvatar = payload.avatar
    //   }
    // },

    /* Aside Mobile */
    asideMobileStateToggle (state, payload = null) {
      const htmlClassName = 'has-aside-mobile-expanded'

      let isShow

      if (payload !== null) {
        isShow = payload
      } else {
        isShow = !state.isAsideMobileExpanded
      }

      if (isShow) {
        document.documentElement.classList.add(htmlClassName)
      } else {
        document.documentElement.classList.remove(htmlClassName)
      }

      state.isAsideMobileExpanded = isShow
    },

    /* Full Page mode */
    fullPage (state, payload) {
      state.isNavBarVisible = !payload
      state.isAsideVisible = !payload
      state.isFooterBarVisible = !payload
    }
  },
  actions: {
    asideDesktopOnlyToggle (store, payload = null) {
      let method

      switch (payload) {
        case true:
          method = 'add'
          break
        case false:
          method = 'remove'
          break
        default:
          method = 'toggle'
      }
      document.documentElement.classList[method]('has-aside-desktop-only-visible')
    },
    toggleFullPage ({ commit }, payload) {
      commit('fullPage', payload)
      const aa = {
        '业务招待1': [
          {label: '1月', value: 23},
          {label: '2月', value: 23},
          {label: '3月', value: 23},
          {label: '4月', value: 23},
        ],
        '业务招待2': [
          {label: '1月', value: 23},
          {label: '2月', value: 23},
          {label: '3月', value: 23},
          {label: '4月', value: 23},
        ]
      }
      document.documentElement.classList[!payload ? 'add' : 'remove']('has-aside-left', 'has-navbar-fixed-top')
    },
    // user login
    login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          let username = userInfo.username.trim()
          if (response.nickName) {
            username = response.nickName
          }
          const { token } = response
          commit('SET_TOKEN', token)
          commit('SET_USER_NAME', username)
          setToken(token)
          setBbsToken(token)
          setUserName(username)
          const attemptedURL = sessionStorage.getItem('attemptedURL')
          if (attemptedURL) {
            router.push(attemptedURL)
            sessionStorage.removeItem('attemptedURL')
          } else {
            // 如果没有尝试访问的URL，跳转到默认页面
            router.push('/')
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 手机验证码登录
    phoneLoginAction ({ commit }, phoneInfo) {
      return new Promise((resolve, reject) => {
        phoneLogin(phoneInfo).then(response => {
          let username = phoneInfo.phone
          if (response.nickName) {
            username = response.nickName
          }
          const { token } = response
          commit('SET_TOKEN', token)
          commit('SET_USER_NAME', username)
          setToken(token)
          setBbsToken(token)
          setUserName(username)
          const attemptedURL = sessionStorage.getItem('attemptedURL')
          if (attemptedURL) {
            router.push(attemptedURL)
            sessionStorage.removeItem('attemptedURL')
          } else {
            // 如果没有尝试访问的URL，跳转到默认页面
            router.push('/')
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    resetToken ({ commit, dispatch }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_USER_NAME', '')
        removeToken()
        removeUserName()
        storage.clear()
        localStorage.removeItem('username') // 从 LocalStorage 移除
        console.log('resetToken success')
        const loginEvent = new CustomEvent('csCustomLoginEvent', {
          detail: {}, // 自定义事件的详细信息
          bubbles: true, // 事件是否冒泡
          cancelable: true // 事件是否可以被取消
        });
        document.dispatchEvent(loginEvent);
        resolve()
      })
    },
    // 退出系统
    LogOut ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(res => {
          // 重置token
          dispatch('resetToken').then(r => {
            resolve()
          }).catch(e => {
            reject(e)
          });
        }).catch(error => {
          reject(error)
        })
      })
    },
    // get user info
    getInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          if (!response || !response.data) {
            // commit('SET_TOKEN', '')
            removeToken()
            resolve()
          }

          // const { roles, name, avatar, introduction, permissions } = response.data

          // roles must be a non-empty array
          // if (!roles || roles.length <= 0) {
          //   // eslint-disable-next-line prefer-promise-reject-errors
          //   reject('getInfo: roles must be a non-null array!')
          // }
          // commit('SET_PERMISSIONS', permissions)
          // commit('SET_ROLES', roles)
          // console.log('set name 222222222', name)
          // commit('SET_NAME', name)
          // commit('SET_AVATAR', avatar)
          // commit('SET_INTRODUCTION', introduction)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    fetch ({ commit }, payload) {
      axios
        .get(`data-sources/${payload}.json`)
        .then((r) => {
          // if (r.data && r.data.data) {
          //   commit('basic', {
          //     key: payload,
          //     value: r.data.data
          //   })
          // }
        })
        .catch(error => {
          alert(error.message)
        })
    }
  }
})
export default store
export function useStore () {
  return store
}
